import clsx from 'clsx'

import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import type { Location } from 'react-router-dom'
import { featureList } from 'components/common/pricing2021/features'
import PricingPopover from 'components/common/pricing2021/pricing-popover'
import DataTable from 'components/ui/data-table'
import DiscoModal from 'components/ui/disco-modal'
import Icon from 'components/ui/icon'
import modalStyles from 'components/utils/modalStyles'
import type { DataTableItem, TableCellContentItem } from './tables-data'
import { dataTables } from './tables-data'
const FeatureTableModal = (): React.ReactNode => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const tableCellContent = (itemType: TableCellContentItem, svg) => {
    if (itemType === 'svg') return svg
    return <span className="Pricing_FeatureTableText">{itemType}</span>
  }

  const renderTableBlock = (item: DataTableItem, tableIndex: number) => {
    const checkSvg = (
      <div className="Pricing_TableSvgWrapper">
        <Icon type="check" />
      </div>
    )
    return (
      <React.Fragment key={tableIndex}>
        <h2 className="Pricing_FeatureTableTitle">{item.header}</h2>
        <DataTable
          columns={item.columns.map(item => ({
            name: item.name,
            render: props => <>{props[item.props]}</>,
          }))}
          data={item.data.map(({ feature, ...plans }, featureIndex) => {
            let absoluteIndex = featureIndex

            for (let i = 1; i <= tableIndex; i++) {
              const prevTable = dataTables[tableIndex - i]
              absoluteIndex += prevTable?.data.length || 0
            }

            const featureDescription = featureList[absoluteIndex]?.description
            const result: Record<string, any> = {
              feature: (
                <PricingPopover
                  isShow={!!featureDescription}
                  popoverProps={{
                    messageClassName: 'Pricing_PricingPopover--Table',
                    description: featureDescription,
                  }}
                >
                  <div
                    className={clsx('Pricing_FeatureTableText', {
                      'Pricing_FeatureTableText--Underlined':
                        featureDescription,
                    })}
                  >
                    {feature.name}
                  </div>
                </PricingPopover>
              ),
            }
            Object.keys(plans).forEach(key => {
              const plan = plans[key]
              result[key] = plan ? tableCellContent(plan, checkSvg) : null
            })
            return result
          })}
          rows={item.data.length}
        />
      </React.Fragment>
    )
  }

  const tables = dataTables.map(renderTableBlock)

  const handleRequestClose = () => {
    navigate(location.state?.returnTo ?? '/settings/billing', { replace: true })
  }

  return (
    <DiscoModal
      style={{
        ...modalStyles,
        content: { ...modalStyles.content, maxWidth: '1185px', width: '100%' },
      }}
      onRequestClose={handleRequestClose}
      showCloseButton
      className="Billing_Pricing2021Container"
    >
      <div className="Pricing_FeatureTableContainer">{tables}</div>
    </DiscoModal>
  )
}

export default FeatureTableModal
